<template>
  <div class="d-flex align-center">
    <v-chip label :color="result === 'REPROVADO' ? 'error' : 'success'" small>
      {{ result }}
    </v-chip>
  </div>
</template>

<script>
export default {
  props: {
    notas: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      result: null,
    };
  },
  mounted() {
    this.calcularResultado();
  },
  watch: {
    notas: {
      handler() {
        this.calcularResultado();
      },
      deep: true, // para detectar mudanças dentro do objeto
    },
  },
  methods: {
    calcularResultado() {
      for (const [id, nota] of Object.entries(this.notas)) {
        if (nota.subetapa?.descricao === "MF") {
          const valor = this.arredondarValue(nota.valor);
          this.result = valor >= 7 ? "APROVADO" : "REPROVADO";
          break;
        }
      }
    },
    arredondarValue(number) {
      const integerPart = Math.floor(number);
      const decimalPart = number - integerPart;

      const lowerLimit = 0.3;
      const upperLimit = 0.7;

      const deci = parseFloat(decimalPart.toFixed(1));

      if (deci >= lowerLimit && deci <= upperLimit) {
        return integerPart + 0.5;
      }
      if (deci >= 0.8) {
        return Math.ceil(number).toFixed(1);
      }

      return Math.floor(number).toFixed(1);
    },
  },
};
</script>
